import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const ProtectedRoute = ({ children, role }) => {
  const { user } = useContext(AuthContext);
  console.log(user);
  return user && user.role === role ? children : <Navigate to="/" />;
};

export default ProtectedRoute;
